<template>
  <div class="success-page">
    <div class="success-page__header">
      <img src="https://assets-cdn.signable.co.uk/images/signable_cropped.svg"  v-if="!$store.state.logoURL" />
      <img :src="$store.state.logoURL"  v-else />
    </div>
    <div class="success-page__content">
      <template v-if="status === 'cancelled'">
        <h3>{{ $t('envelopeComplete.envelopeCancelled') }}</h3>
        <message type="error">
          {{ $t('envelopeComplete.envelopeCancelledMessage', { name: companyName }) }}
        </message>
      </template>
      <template v-else-if="status === 'rejected'">
        <message type="error">
          <h3>{{ $t('envelopeComplete.envelopeRejected') }}</h3>
          <span>{{ $t('envelopeComplete.envelopeRejectedMessage') }}</span>
        </message>
      </template>
      <template v-else-if="status === 'signed'">
        <message type="success">
          <h3>{{ $t('envelopeComplete.envelopeAccepted') }}</h3>
          <span>{{ $t('envelopeComplete.envelopeAcceptedMessage') }}</span>
        </message>
        <a :href="`${url}/envelope/download/${requestedEnvelope.envelope_fingerprint}/${requestedEnvelope.signature_fingerprint}/${clientId}`" class="success-page__download">{{ $t('envelopeComplete.download') }}</a>
      </template>
      <template v-else-if="status === 'expired'">
        <message type="error">
          <h3>{{ $t('envelopeComplete.envelopeExpired') }}</h3>
          <span>{{ $t('envelopeComplete.envelopeExpiredMessage', { name: companyName }) }} </span>
        </message>
      </template>
      <template v-else>
        <message type="warning">
          <h3>{{ $t('envelopeComplete.envelopeAwaiting') }}</h3>
          <span>{{ $t('envelopeComplete.envelopeAwaitingMessage') }}</span>
        </message>
      </template>
      <div class="boxes" v-if="status === 'signed' || status === 'sent'">
        <h2>{{ $t('envelopeComplete.wasntThatEasy') }}</h2>
        <p>{{ $t('envelopeComplete.promoMessage') }}</p>
        <div class="grid">
          <div class="grid__item grid__item--4">
            <div class="boxes__item">
              <div class="boxes__item__icon">
                <icon name="check" height="35" width="35"></icon>
              </div>
              <div class="boxes__item__content">
                {{ $t('envelopeComplete.trackDocumentProgress') }}
              </div>
            </div>
          </div>
          <div class="grid__item grid__item--4">
            <div class="boxes__item">
              <div class="boxes__item__icon">
                <icon name="check" height="35" width="35"></icon>
              </div>
              <div class="boxes__item__content">
                {{ $t('envelopeComplete.accessOTG') }}
              </div>
            </div>
          </div>
          <div class="grid__item grid__item--4">
            <div class="boxes__item">
              <div class="boxes__item__icon">
                <icon name="check" height="35" width="35"></icon>
              </div>
              <div class="boxes__item__content">
                {{ $t('envelopeComplete.cutCosts') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-if="$store.state.config.company_id !== '46460'">
      <div class="success-page__content" v-if="status === 'signed' || status === 'sent'">
        <a href="https://app.signable.co.uk/signup-trial?utm_source=new-signing-page" class="success-page__sign-up" v-html="$t('envelopeComplete.signUpForTrial')"></a>
      </div>
    </template>
    <div class="success-page__content">
      <span>{{ $t('envelopeComplete.signedVia') }}</span>
      <a href="https://app.signable.co.uk/signup-trial?utm_source=new-signing-page">Signable.</a>
      <span>{{ $t('envelopeComplete.nowNotNextWeek') }}</span>
    </div>
  </div>
</template>

<script>
  import Message from '@/components/Message';

  export default {
    name: 'envelope-complete',
    props: ['status', 'companyName', 'clientId', 'requestedEnvelope'],
    components: {
      Message,
    },
    computed: {
      url() {
        let url;
        if (window.location.hostname === 'localhost') {
          url = 'http://localhost:8888';
        } else {
          url = 'https://app.signable.co.uk';
        }
        return url;
      },
    },
  };
</script>

<style lang="sass" scoped>
  @import '~styles/component-utils.sass'
  .success-page
    max-width: 95%
    width: 960px
    margin: $spacing-large auto
    background-color: #fff
    border: 1px solid $color-border
    &__header
      border-bottom: 1px solid $color-border
      padding: $spacing-base
      img
        width: 250px
        margin: 0 auto
    &__logo
      max-width: 180px
      width: 95%
      margin: 0 auto
    &__content
      padding: $spacing-base
      text-align: center
      border-top: 1px solid $color-border
      &:first-child
        border-top: 0
      a.success-page__download
        margin-top: $spacing-base
        display: block
    &__sign-up
      background-color: $color-grey-dark
      max-width: 100%
      width: 250px
      margin: 0 auto
      color: #fff
      padding: $spacing-base
      line-height: 1.5
      text-decoration: none
      display: block
      span
        font-weight: bold
        color: $color-main
  .boxes
    max-width: 75%
    margin: $spacing-large auto $spacing-base
    border: 2px solid $color-main
    padding: $spacing-base
    border-radius: 10px
    &__item
      padding: $spacing-base
      &__icon
        margin: $spacing-small 0
        svg
          margin: 0
          background-color: $color-main
          padding: $spacing-small
          color: #fff
          border-radius: 30px
  @media screen and (max-width: $screen-size-large)
    .success-page
      .boxes
        max-width: 100%
</style>



// WEBPACK FOOTER //
// EnvelopeComplete.vue?1dca6d7b